import React from 'react';
import { ADD_GADGET_EXPERIENCE } from '@atlassian/jira-dashboard-common/src/constants.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { PACKAGE_NAME } from '../../../../constants.tsx';
import { useRightPanelState } from '../../../../controllers/right-panel-layout-controller.tsx';
import { AddGadgetPanelSkeleton } from './add-gadget-panel-skeleton/index.tsx';
import { Fallback, FALLBACK_TYPE } from './fallback/index.tsx';
import type AddGadgetPanelType from './main.tsx';
import { PanelContainer } from './styled.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAddGadgetPanel = lazy<typeof AddGadgetPanelType>(
	() => import(/* webpackChunkName: "async-add-gadget-panel" */ './main'),
);

export const AsyncAddGadgetPanel = () => {
	const { isOpen: isRightPanelOpen } = useRightPanelState();
	if (isRightPanelOpen === false) {
		return null;
	}

	return (
		<JSErrorBoundary
			id="add-gadget"
			packageName={PACKAGE_NAME}
			attributes={{
				task: ADD_GADGET_EXPERIENCE,
				reason: 'AsyncAddGadgetPanel ErrorBoundary',
			}}
			fallback={() => (
				<PanelContainer>
					<Fallback type={FALLBACK_TYPE.ERROR} />
				</PanelContainer>
			)}
			withExperienceTracker
		>
			<Placeholder name="add-gadget-panel" fallback={<AddGadgetPanelSkeleton />}>
				<LazyAddGadgetPanel />
			</Placeholder>
		</JSErrorBoundary>
	);
};
